<template>
  <div v-show="isShowFAQIcon" id="faq">
    <el-popover placement="top" trigger="hover" popper-class="dark">
      <div>{{ $t("FAQ.IconPopover") }}</div>
      <div
        slot="reference"
        class="float-icon__entry common-question"
        @click="openFAQDialog"
      >
        <pre>{{ $t("FAQ.TitleWrap") }}</pre>
      </div>
    </el-popover>

    <el-dialog
      :visible.sync="isShowFAQDialog"
      :show-close="!isShowVideo"
      width="1000px"
      center
    >
      <!-- 一般模式 -->
      <div v-if="!isShowVideo" class="main">
        <div class="main__left--img"></div>
        <div class="main__right--content">
          <div class="title">
            {{ $t("FAQ.Title") }}
          </div>
          <div class="items">
            <ul>
              <li
                v-for="(item, index) in faqItemList"
                :key="item"
                @click="clickFAQItem(index, item)"
              >
                <p>{{ `${index + 1}. ${item}` }}</p>
              </li>
            </ul>
          </div>
          <a
            href="https://www.smartdaily.com.tw/smartdailyfaq/"
            target="_blank"
            class="faq-page-button btn-primary"
          >{{ $t("FAQ.FaqPageButton") }}</a>
        </div>
      </div>
      <!-- 點擊 7. 顯示影片模式 -->
      <iframe
        v-else
        width="1000"
        height="590"
        src="https://www.youtube.com/embed/s8TGdDOTmiU"
        frameborder="0"
        allowfullscreen
      >
      </iframe>
      <!-- 影片模式要提供特規的 close button 避免該按鈕融入影片中 -->
      <i v-if="isShowVideo" class="icon-input-error" @click="closeVideo"></i>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShowFAQDialog: false,
      faqItemList: [
        this.$t('FAQ.PostalRegistrationMistake'),
        this.$t('FAQ.PostalWrongTablet'),
        this.$t('FAQ.PostalWrongCommunity'),
        this.$t('FAQ.PostalReturnNotCollected'),
        this.$t('FAQ.PostalReturnRetrieval'),
        this.$t('FAQ.PostalReturnToCarrier'),
        this.$t('FAQ.ComputerIssue')
      ],
      isShowVideo: false
    }
  },
  computed: {
    isShowFAQIcon () {
      const isPostal = this.$store.getters.isServiceEnabled(49) // 郵務功能開關
      const isTechNum = this.$store.state.localStorage.techNum // 引導提示開關
      return isPostal && isTechNum
    }
  },
  methods: {
    openFAQDialog () {
      this.isShowFAQDialog = true
    },
    closeFAQDialog () {
      this.isShowFAQDialog = false
    },
    clickFAQItem (index, item) {
      let link = ''
      const oneBasedIndex = index + 1
      switch (oneBasedIndex) {
      case 1:
        link = 'postalList.aspx'
        localStorage.setItem('postalListStatus', 'Cancel')
        break
      case 2:
        link = 'postalList.aspx'
        localStorage.setItem('postalListStatus', 'Return')
        break
      case 3:
        link = 'postalReturn.aspx'
        break
      case 4:
        link = 'postalReturnList.aspx'
        localStorage.setItem('postalReturnListStatus', 'Receive')
        break
      case 5:
        link = 'postalReturnList.aspx'
        localStorage.setItem('postalReturnListStatus', 'Cancel')
        break
      case 6:
        link = 'postalReturnList.aspx'
        localStorage.setItem('postalReturnListStatus', 'Returns')
        break
      case 7:
        this.openVideo()
        return
      }
      this.$confirm(`確認離開此頁面，進入「${item}」的操作畫面？`, '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      })
        .then(() => {
          window.location.href = `${window.location.origin}/community/${link}`
        })
        .catch((e) => {
          console.error(e)
          // 無須進行錯誤處理
        })
    },
    openVideo () {
      this.isShowVideo = true
    },
    closeVideo () {
      this.closeFAQDialog()
      setTimeout(() => {
        this.isShowVideo = false
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.float-icon__entry {
  background: $warnColor;
  border-radius: 100%;
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px; // 維持既有樣式，未轉為 $fontSize
  font-weight: 700;
  color: white;
  transform: translate3d(0, 0, 0); // 使動畫更加流暢
  transition: transform ease-out 200ms;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  position: fixed;
  bottom: 235px; // 先維持既有寫死的方式
  right: 30px;
  z-index: 20;

  &:hover {
    transform: scale(1.2, 1.2) translate3d(0, 0, 0);
  }
}
::v-deep .el-dialog__header {
  padding: 0;
}
::v-deep .el-dialog--center .el-dialog__body {
  padding: 0;
  height: 590px;

  .main {
    height: 590px;
    display: flex;
    .main__left--img {
      flex: 0 0 40%;
      background-image: url("../../assets/img/common/FAQ.jpg");
      background-size: cover;
    }
    .main__right--content {
      flex: 0 0 60%;
      padding: 50px 50px 30px 50px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      font-size: map-get($fontSize, large);
      .title {
        flex: 0 0 43px;
        color: $mainColor;
        font-size: map-get($fontSize, xxx-large);
        font-weight: 700;
      }
      .items {
        overflow-y: auto;
        flex: 1;
        /* min-height: 0; */
        li {
          border-bottom: solid 1px $bgDark1;
          padding: 10px 0px;
          p {
            line-height: 1.42; // 否則文字會太擁擠
            font-weight: 700;
          }
          &:hover {
            color: $mainColor;
            cursor: pointer;
          }
        }
      }
      .faq-page-button {
        flex: 0 0 40px;
        display: block;
        width: 170px;
        height: 40px;
        line-height: 42px;
        text-align: center;
        font-size: map-get($fontSize, x-large);
        border-radius: 20px;
        margin: 32px auto 0;
        cursor: pointer;
        background-color: $mainColor;
        color: #fff;
      }
    }
  }

  .icon-input-error {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    font-size: map-get($fontSize, xxx-large);
    background-color: #fff;
    border-radius: 100%;
    cursor: pointer;
  }
}
</style>
